<template>
    <button class="btn_back me-2" @click="goBack">
        <i class="fa-regular fa-arrow-left icon"></i>
    </button>
</template>
<script setup>

const goBack = () => {
    history.back();
};
</script>

<style scoped>
 button {
    padding: 8px 10px;
    border: none;
    background: none;
    color: #2c3e50;
    font-weight: 600;
    font-size: 16px;
    border-radius: 4px;
    cursor: pointer;
    outline: none;
    transition: background-color 0.3s ease;
    margin-left: -5px;
}

.dark button {
  color: #a1bedb;
}
  
 button:hover,
 button:focus {
    background-color: #d7d7d7;
  }

  .dark button:hover,
  .dark button:focus {
    background-color: #2e333d;
  }
  
 button:active {
    background-color: #d7d7d7;
  }
  
 button:disabled {
    background-color: #cccccc;
    cursor: not-allowed;
  }

.icon {
    margin: 0 !important;
}
</style>